export default __webpack_public_path__ + "static/media/fa1.eac9ce45.jpg";